/** English copy. Source-of-truth — every other locale should mirror these keys. */
export const en: Record<string, string> = {
  "nav.terminal": "Terminal",
  "nav.portfolio": "Portfolio",
  "nav.orders": "Orders",
  "nav.fills": "Fills",
  "nav.alerts": "Alerts",
  "nav.discover": "Discover",
  "nav.complaints": "Complaints",
  "nav.account": "Account",
  "nav.api_keys": "API keys",
  "nav.tearsheet": "Tearsheet",
  "nav.profile": "Profile & MFA",

  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.delete": "Delete",
  "common.loading": "Loading…",
  "common.error.generic": "Something went wrong. Please retry.",

  "auth.login.title": "Log in",
  "auth.login.email": "Email",
  "auth.login.password": "Password",
  "auth.login.submit": "Log in",
  "auth.login.demo": "Open demo account",

  "complaint.cta.new": "New complaint",
  "complaint.empty": "No complaints filed",

  "apikey.title": "API keys",
  "apikey.description": "Programmatic access for headless clients.",
  "apikey.create": "Create key",
  "apikey.revoke": "Revoke",
  "apikey.warn.once": "This is the only time the plaintext key is shown.",
};
